import { render, staticRenderFns } from "./IconHubsCancel.vue?vue&type=template&id=08df25fe&"
import script from "./IconHubsCancel.vue?vue&type=script&lang=js&"
export * from "./IconHubsCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08df25fe')) {
      api.createRecord('08df25fe', component.options)
    } else {
      api.reload('08df25fe', component.options)
    }
    module.hot.accept("./IconHubsCancel.vue?vue&type=template&id=08df25fe&", function () {
      api.rerender('08df25fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconHubsCancel.vue"
export default component.exports